"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundManager = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var react_router_1 = require("react-router");
var fos_ui_1 = require("@ntet/fos-ui");
var routes_1 = require("../../auth/routes");
// eslint-disable-next-line import/prefer-default-export
var FundManager = function () {
    var history = (0, react_router_1.useHistory)();
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(fos_ui_1.Button, { onClick: function () { return history.push(routes_1.routes.logout); } }, "Sign Out")));
};
exports.FundManager = FundManager;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: 20rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: 20rem;\n"])));
var templateObject_1;
